<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            dữ liệu trainning</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tiêu đề:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Tiêu đề..." v-model="search.cTieuDe" />
              </el-col>
            </el-row>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Mô tả:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Mô tả..." v-model="search.cMoTa" />
              </el-col>
            </el-row>
          </el-col> -->
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6 d-flex">
            <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm dữ liệu trainning</span>
            </el-button>
            <el-button plain type="success" data-bs-toggle="modal" data-bs-target="#modal_upload"
              @click="handleOpenUpload">
              <span class="btn-inner--icon"><i class="fas fa-upload"></i></span>
              Tải lên dữ liệu
            </el-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="id" show-overflow-tooltip class="text-nowrap" label="Mã" width="80" align="center">
            </el-table-column>
            <el-table-column prop="cTieuDe" show-overflow-tooltip class="text-nowrap" label="Tiêu đề">
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="150">
              <template #default="scope">
                <el-button plain type="primary" :disabled="scope.row.nTrangThai == 0" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>
                <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm dữ liệu trainning" : "Cập nhật dữ liệu trainning" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item label="Tiêu đề" prop="cTieuDe">
                <el-input v-model="formData.cTieuDe" />
              </el-form-item>
              <el-form-item label="Nội dung" prop="cNoiDung">
                <el-input v-model="formData.cNoiDung" type="textarea" :rows="10" />
                <span class="form-footnote">Để đặt dữ liệu tranning làm mặc định thêm "<span class="fw-bold">Quy tắc
                    chat
                    bot mặc định</span>" vào trong nội dung</span>
              </el-form-item>

            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal_upload" ref="uploadModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-700px">
        <div class="modal-content">

          <div class="modal-header">
            <h2 class="fw-bolder">Tải lên file</h2>
            <div class="btn btn-sm btn-icon" data-bs-dismiss="modal" @click="closeUpload">
              ✕
            </div>
          </div>

          <div class="modal-body">
            <el-form :model="uploadForm" ref="uploadFormRef" label-width="120px" class=" d-flex flex-column">

              <el-form-item label="Tiêu đề" required>
                <el-input v-model="uploadForm.cTieuDe" />
              </el-form-item>

              <el-form-item label="File" required>
                <input id="upload_file_input" type="file" accept=".pdf,.doc,.docx" @change="handleFileChange" />
                <div class="mt-2 d-flex flex-column">
                  <span class="form-footnote lh-1"> Chỉ nhận định dạng .pdf, .doc, .docx </span>
                  <span class="text-danger form-footnote lh-1 mt-1">Lưu ý: Chỉ tải lên định dạng .pdf được export từ docx</span>
                </div>
              </el-form-item>



              <!-- <div v-if="selectedFile">
                Đã chọn: {{ selectedFile.name }}
              </div> -->

            </el-form>
          </div>

          <div class="modal-footer">
            <el-button type="primary" :loading="isLoading" @click="submitUpload">
              Tải lên
            </el-button>
            <el-button type="danger" @click="closeUpload">Hủy</el-button>
          </div>

        </div>
      </div>
    </div>

    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { Trainning } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
/* import ImageResize from "quill-image-resize"; */
import { baseUrl } from "@/utils/global";
/* import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'; */
import { ElMessage } from "element-plus";

/* Quill.register("modules/imageResize", ImageResize); */

export default {
  name: 'Trainning',
  /*   components: {
      QuillEditor
    }, */
  data() {
    return {
      search: {
        cTieuDe: "",
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        id: null,
        cTieuDe: "",
        cNoiDung: "",
        nTrangThai: 1,
      },
      rules: {
        cTieuDe: [{ required: true, message: "Xin vui lòng điền Tiêu đề", trigger: "blur" }],
        cNoiDung: [{ required: true, message: "Xin vui lòng điền Nội dung", trigger: "blur" }],
      },
      tableData: {
        content: [{}]
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      dialogImageUrl: null,
      dialogVisible: false,
      uploadForm: {
        cTieuDe: "",
        cNoiDung: "",
        nTrangThai: 1
      },
      selectedFile: null,
    }
  },
  methods: {
    handleOpenUpload() {
      this.resetUploadState()
    },

    submitUpload() {
      if (!this.uploadForm.cTieuDe) {
        ElMessage.error("Thiếu tiêu đề");
        return;
      }

      if (!this.selectedFile) {
        ElMessage.error("Xin vui lòng chọn file");
        return;
      }

      const formData = new FormData();

      formData.append(
        "record",
        new Blob([JSON.stringify(this.uploadForm)], {
          type: "application/json"
        })
      );

      formData.append("file", this.selectedFile);

      this.isLoading = true;

      this.store.dispatch(Trainning.saveFromFile, formData)
        .then(res => {
          if (res.code === 200) {
            ElMessage.success("Tải lên thành công");
            this.handleFindPage();
            this.closeUpload();
          } else {
            ElMessage.error(res.msg || "Tải lên thất bại");
          }
        })
        .catch(() => {
          ElMessage.error("Tải lên thất bại");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowed = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ];

      if (!allowed.includes(file.type)) {
        ElMessage.error("Chỉ nhận file PDF / DOC / DOCX");
        return;
      }

      this.selectedFile = file;
    },

    resetUploadState() {
      this.uploadForm = {
        cTieuDe: "",
        cNoiDung: "",
        nTrangThai: 1
      };
      this.selectedFile = null;

      // also clear file input DOM (important)
      const input = this.$el.querySelector('#upload_file_input');
      if (input) input.value = "";
    },

    closeUpload() {
      this.resetUploadState()
      hideModal(this.$refs.uploadModalRef);
    },

    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
      /* this.$refs.quillEditor.setHTML("") */
    },
    handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
      /* this.$refs.quillEditor.setHTML(val.cNoiDung) */

    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa dữ liệu trainning này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Trainning.deleteTrainning, val.id).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa dữ liệu trainning thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa dữ liệu trainning thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cTieuDe: { value: this.search.cTieuDe },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(Trainning.findPageTrainning, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm dữ liệu thất bại", type: "error" });
      })
    },
    handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu dữ liệu trainning này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {

            const formData = new FormData()
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            if (this.operation) {
              this.store.dispatch(Trainning.saveTrainning, this.formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật dữ liệu trainning thành công", type: "success" })
                } else {
                  ElMessage({ message: "Cập nhật dữ liệu trainning không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật dữ liệu trainning không thành công", type: "error" })
              })
            } else {
              this.store.dispatch(Trainning.saveTrainning, this.formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm dữ liệu trainning mới  thành công", type: "success" })
                } else {
                  ElMessage({ message: "Thêm dữ liệu trainning mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm dữ liệu trainning mới không thành công", type: "error" })
              })
            }
          }).catch(() => {

          })
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss">
.form-footnote {
  font-size: 1rem;
  color: #4d52579c;
}
</style>